module.exports = __webpack_public_path__ + "img/paytable_icon.0d28a2d2.svg";